
// // src/hooks/useAutoLogout.js
// import { useEffect, useRef, useCallback } from "react";
// import { supabase } from "../lib/supabase";

// const useAutoLogout = (user, timeout = 15 * 60 * 1000) => {
// // const useAutoLogout = (user, timeout = 10000) => { // 10,000 milliseconds = 10 seconds
//   const timer = useRef(null);
  
//   const resetTimer = useCallback(() => {
//     console.log('resetTimer called');
//     if (timer.current) clearTimeout(timer.current);
    
//     if (user) {
//       timer.current = setTimeout(async () => {
//         try {
//           console.log('Timer expired, checking session...');
//           const { data: { session } } = await supabase.auth.getSession();
//           if (session) {
//             console.log('About to sign out...');
//             await supabase.auth.signOut();
//             console.log('Signed out, redirecting...');
//             window.location.href = "/";
//           }
//         } catch (error) {
//           console.error('Auto logout error:', error);
//         }
//       }, timeout);
//     }
//   }, [user, timeout]);
  
//   useEffect(() => {
//     if (!user) return;
    
//     const events = ["mousemove", "keydown", "click", "scroll", "touchstart"];
//     events.forEach((event) => window.addEventListener(event, resetTimer));
    
//     resetTimer();
    
//     return () => {
//       events.forEach((event) => window.removeEventListener(event, resetTimer));
//       if (timer.current) clearTimeout(timer.current);
//     };
    
//   }, [user, resetTimer]);
// };

// export default useAutoLogout;

import { useEffect, useRef, useCallback } from "react";
import { supabase } from "../lib/supabase";

const useAutoLogout = (user, inactivityTimeout = 15 * 60 * 1000) => {
// const useAutoLogout = (user, inactivityTimeout = 10 * 1000) => {
  const inactivityTimer = useRef(null);
  const sessionCheckInterval = useRef(null);
  
  const resetInactivityTimer = useCallback(() => {
    if (inactivityTimer.current) clearTimeout(inactivityTimer.current);
    
    if (user) {
      inactivityTimer.current = setTimeout(async () => {
        try {
          await supabase.auth.signOut();
          window.location.href = "/";
        } catch (error) {
          console.error('Auto logout error:', error);
        }
      }, inactivityTimeout);
    }
  }, [user, inactivityTimeout]);
  
  const checkSessionValidity = useCallback(async () => {
    if (!user) return;
    
    try {
      const { data: { session }, error } = await supabase.auth.getSession();
      
      if (error || !session) {
        await supabase.auth.signOut();
        window.location.href = "/";
      }
    } catch (error) {
      console.error('Session check error:', error);
    }
  }, [user]);
  
  useEffect(() => {
    if (!user) return;
    
    const events = ["mousemove", "keydown", "click", "scroll", "touchstart"];
    events.forEach((event) => window.addEventListener(event, resetInactivityTimer));
    resetInactivityTimer();
    
    sessionCheckInterval.current = setInterval(checkSessionValidity, 3 * 60 * 1000);
    checkSessionValidity();
    
    return () => {
      events.forEach((event) => window.removeEventListener(event, resetInactivityTimer));
      if (inactivityTimer.current) clearTimeout(inactivityTimer.current);
      if (sessionCheckInterval.current) clearInterval(sessionCheckInterval.current);
    };
    
  }, [user, resetInactivityTimer, checkSessionValidity]);
};

export default useAutoLogout;